export const getProjectId = () => window.location.pathname.split('/').pop()
